export default __webpack_public_path__ + "static/media/184.4419bb28.jpg";